<template>
  <ContentBanner
    :variant="bannerConfig.variant"
    :icon="bannerConfig.icon"
    :title="bannerConfig.title"
    primary-label="Create Acknowledgement"
  >
    <p class="text-body-3 text-textLight mb-0">
      This employee's latest acknowledgement was signed over
      <strong>{{ acknowledgementCycleSla }}</strong> days ago.
      <a
        href="https://help.datapeople.io/article/342-acknowledgements-slas"
        target="_blank"
        rel="noopener noreferrer"
        class="text-primary text-decoration-none cursor-pointer"
        @click.stop
      >Read more here.</a>
    </p>
    <template #actions>
      <HideRbac :permissions="['createEmployeeJobProfileAcknowledgements']">
        <DpplDarkTooltip
          v-if="!isActionEnabled"
          tooltip-placement="bottom"
          light-mode
        >
          <template #activator="{ onMouseenter, onMouseleave }">
            <span
              class="banner-action-disabled-wrapper"
              @mouseenter="onMouseenter"
              @mouseleave="onMouseleave"
            >
              <v-btn
                color="brandPrimary"
                variant="flat"
                size="small"
                disabled
              >
                Create Acknowledgement
              </v-btn>
            </span>
          </template>
          <template #tooltip-content>
            <p class="text-body-2 text-textDark">
              {{ disabledTooltip }}
            </p>
          </template>
        </DpplDarkTooltip>
        <v-btn
          v-else
          color="brandPrimary"
          variant="flat"
          size="small"
          @click="handleCreateClick"
        >
          Create Acknowledgement
        </v-btn>
      </HideRbac>
    </template>
  </ContentBanner>
</template>

<script setup>
import ContentBanner from '@/components/library/ContentBanner.vue';
import DpplDarkTooltip from '@/components/datapeople/DpplDarkTooltip.vue';
import HideRbac from '@/components/rbac/HideRbac.vue';
import { useTracking } from '@/stores/tracking/tracking';
import { ACKNOWLEDGEMENT_PREVIEW_BANNER_CONFIG } from '@/helpers/acknowledgementAlerts';

const bannerConfig = ACKNOWLEDGEMENT_PREVIEW_BANNER_CONFIG.acknowledgement_out_of_date;

defineProps({
  acknowledgementCycleSla: { type: [Number, String], default: null },
  isActionEnabled: { type: Boolean, default: true },
  disabledTooltip: { type: String, default: '' },
});

const emit = defineEmits(['create']);

const handleCreateClick = () => {
  useTracking().ackLibClickedCreate({ location: 'In Sidebar Alert window' });

  emit('create');
};
</script>
